import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

type Props = {
  children?: React.ReactNode;
};

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageBodyDiv: {
      backgroundColor: theme.palette.background.default,
      width: "100%",
      height: "100%",
    },
  })
);

/** ページボディDIV */
export function PageBodyDiv(props: Props) {
  const classes = useStyles();
  const { children } = props;
  return <div className={classes.pageBodyDiv}>{children}</div>;
}
